import React, { Component, createRef } from 'react';
import { withTranslation } from 'react-i18next';
import { toPng } from 'html-to-image';
import { FaIcon } from '../FaIcon';

class CopyImageButtonComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            copied: false,
            copying: false,
        };
        this.wrapperRef = createRef();
        this.handleCopy = this.handleCopy.bind(this);
    }

    async handleCopy() {
        const { t } = this.props;
        const target = this.wrapperRef.current;
        if (!target) return;

        this.setState({ copying: true });

        try {
            const dataUrl = await toPng(target, {
                backgroundColor: '#ffffff',
                pixelRatio: 2,
                filter: (node) => {
                    return !node.classList?.contains('copy-image-btn');
                },
            });

            const res = await fetch(dataUrl);
            const blob = await res.blob();

            await navigator.clipboard.write([
                new ClipboardItem({ 'image/png': blob })
            ]);

            this.setState({ copied: true, copying: false });
            setTimeout(() => this.setState({ copied: false }), 2000);
        } catch (err) {
            this.setState({ copying: false });
            alert(t('data_explorer.copy_error', 'No se pudo copiar la imagen'));
        }
    }

    renderButton() {
        const { t } = this.props;
        const { copied, copying } = this.state;

        const tooltip = copied
            ? t('data_explorer.copied', 'Copiado')
            : t('data_explorer.copy_image', 'Copiar imagen');

        return (
            <button
                type="button"
                className={`copy-image-btn${copied ? ' -copied' : ''}`}
                onClick={this.handleCopy}
                disabled={copying}
                title={tooltip}
            >
                <FaIcon iconName={copied ? 'check' : 'copy'} />
            </button>
        );
    }

    render() {
        const { children } = this.props;

        const button = this.renderButton();

        // Render prop: children recibe el botón y decide dónde ponerlo
        if (typeof children === 'function') {
            return (
                <div className="copy-image-btn-wrapper" ref={this.wrapperRef}>
                    {children(button)}
                </div>
            );
        }

        // Fallback: botón en el header (compatibilidad)
        return (
            <div className="copy-image-btn-wrapper" ref={this.wrapperRef}>
                {children}
                {button}
            </div>
        );
    }
}

export const CopyImageButton = withTranslation()(CopyImageButtonComponent);
